export const Statistic = () => {
    return (
      <>
       <div>Statistic</div>
      </>
    );
  };